/* Midway add-to-bag sheet, load more and mobile filter pills (added by Claude, draft theme) */

/* Also load the product-page helper on collection pages, so the quick add panel crosses out sold-out sizes */
(function () {
  if (window.mwPdpInit || window.mwPdpLoading) return;
  var cs = document.currentScript;
  if (!cs || !cs.src || cs.src.indexOf('midway-sheet.js') === -1) return;
  window.mwPdpLoading = true;
  var s = document.createElement('script');
  s.src = cs.src.replace('midway-sheet.js', 'midway-pdp.js');
  s.defer = true;
  document.head.appendChild(s);
})();

(function () {
  if (window.mwSheetInit) return;
  window.mwSheetInit = true;

  var sheet = null;
  var state = null;
  var lastFocus = null;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function findVariant(fn) {
    for (var i = 0; i < state.data.variants.length; i++) { if (fn(state.data.variants[i])) return state.data.variants[i]; }
    return null;
  }
  function msg(text) { q('[data-mw-sheet-msg]', sheet).textContent = text || ''; }

  function updateImage() {
    var img = q('[data-mw-sheet-img]', sheet);
    var src = state.data.img;
    state.data.colors.forEach(function (c) { if (c.n === state.color && c.img) src = c.img; });
    if (src) { img.src = src; img.hidden = false; } else { img.hidden = true; }
  }

  function updatePrice() {
    var v = state.variant ||
      findVariant(function (x) { return (state.data.cidx < 0 || x[1] === state.color) && x[3]; }) ||
      state.data.variants[0];
    var p = q('[data-mw-sheet-price]', sheet);
    p.textContent = '';
    if (!v) return;
    if (v[5] && v[5] > v[4]) {
      p.appendChild(el('span', 'mw-price--sale', money(v[4])));
      p.appendChild(el('s', 'mw-price--was', money(v[5])));
    } else {
      p.textContent = money(v[4]);
    }
  }

  function renderColors() {
    var wrap = q('[data-mw-sheet-colors]', sheet);
    var name = q('[data-mw-sheet-colorname]', sheet);
    wrap.textContent = '';
    name.textContent = state.color || '';
    if (state.data.colors.length < 2) { wrap.hidden = true; return; }
    wrap.hidden = false;
    state.data.colors.forEach(function (c) {
      var b = el('button', 'mw-sheet__color');
      b.type = 'button';
      b.setAttribute('aria-label', c.n);
      b.setAttribute('aria-pressed', c.n === state.color ? 'true' : 'false');
      if (c.thumb || c.img) {
        var i = el('img');
        i.src = c.thumb || c.img;
        i.alt = '';
        i.loading = 'lazy';
        b.appendChild(i);
      } else {
        b.textContent = c.n;
      }
      b.addEventListener('click', function () {
        state.color = c.n;
        state.variant = null;
        msg('');
        renderColors();
        renderSizes();
        updatePrice();
        updateImage();
      });
      wrap.appendChild(b);
      if (c.n === state.color) setTimeout(function () { b.scrollIntoView({ block: 'nearest', inline: 'center' }); }, 30);
    });
  }

  function renderSizes() {
    var wrap = q('[data-mw-sheet-sizes]', sheet);
    var box = q('[data-mw-sheet-sizewrap]', sheet);
    wrap.textContent = '';
    if (state.data.mode === 'single') {
      box.hidden = true;
      state.variant = state.data.variants[0];
      return;
    }
    if (state.data.sidx < 0) {
      box.hidden = true;
      state.variant = findVariant(function (v) { return v[1] === state.color; });
      return;
    }
    box.hidden = false;
    state.data.variants.forEach(function (v) {
      if (state.data.cidx >= 0 && v[1] !== state.color) return;
      var b = el('button', 'mw-sheet__size', v[2]);
      b.type = 'button';
      b.setAttribute('aria-pressed', state.variant && state.variant[0] === v[0] ? 'true' : 'false');
      if (!v[3]) {
        b.disabled = true;
        b.setAttribute('aria-label', 'Size ' + v[2] + ' sold out');
      }
      b.addEventListener('click', function () {
        state.variant = v;
        wrap.querySelectorAll('.mw-sheet__size').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        msg('');
        updatePrice();
      });
      wrap.appendChild(b);
    });
  }

  function open(card) {
    sheet = q('[data-mw-sheet]');
    if (!sheet || !card) return;
    var json = card.querySelector('[data-mw-product]');
    if (!json) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }
    var pressed = card.querySelector('.mw-swatch[aria-pressed="true"]');
    var color = '';
    if (pressed) {
      color = pressed.getAttribute('data-mw-color');
    } else {
      for (var i = 0; i < data.variants.length; i++) { if (data.variants[i][0] === data.base) color = data.variants[i][1]; }
    }
    state = { card: card, data: data, color: color, variant: null };
    q('[data-mw-sheet-title]', sheet).textContent = data.title;
    q('[data-mw-sheet-vendor]', sheet).textContent = data.vendor || '';
    q('[data-mw-sheet-link]', sheet).setAttribute('href', data.url);
    msg('');
    renderColors();
    renderSizes();
    updatePrice();
    updateImage();
    lastFocus = document.activeElement;
    /* Lift the sheet above Shopify's preview bar (only present when previewing a theme) */
    var panel = q('.mw-sheet__panel', sheet);
    var bar = document.getElementById('preview-bar-iframe');
    var barH = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    if (panel && window.matchMedia('(max-width: 699px)').matches) panel.style.bottom = barH ? barH + 'px' : '';
    sheet.hidden = false;
    document.documentElement.classList.add('mw-sheet-open');
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      var x = q('.mw-sheet__x', sheet);
      if (x) x.focus();
    });
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('mw-sheet-open');
    setTimeout(function () { sheet.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function add() {
    if (!state) return;
    var v = state.variant;
    if (!v) { msg(state.data.sidx >= 0 ? 'Select a size' : 'Select a color'); return; }
    if (!v[3]) { msg('That option is sold out'); return; }
    var form = state.card.querySelector('.mw-atc__form');
    var input = form && form.querySelector('input[name="id"]');
    if (!input) { window.location.href = state.data.url; return; }
    input.value = v[0];
    var btn = q('[data-mw-sheet-add]', sheet);
    btn.setAttribute('aria-busy', 'true');
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
    setTimeout(function () {
      btn.removeAttribute('aria-busy');
      close();
    }, 450);
  }

  /* Load more */
  function loadMore(a) {
    if (a.getAttribute('aria-busy') === 'true') return;
    var label = a.textContent;
    a.setAttribute('aria-busy', 'true');
    a.textContent = 'Loading\u2026';
    var url = new URL(a.getAttribute('href'), window.location.origin);
    var view = new URLSearchParams(window.location.search).get('view');
    if (view) url.searchParams.set('view', view);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = q('.mw-grid');
        doc.querySelectorAll('.mw-grid [data-mw-card]').forEach(function (c) {
          grid.appendChild(document.importNode(c, true));
        });
        var shown = grid.querySelectorAll('[data-mw-card]').length;
        var total = parseInt(a.getAttribute('data-mw-total'), 10) || 0;
        var s = q('[data-mw-shown]');
        if (s) s.textContent = shown;
        var bar = q('[data-mw-progress]');
        if (bar && total) bar.style.width = Math.min(100, (shown * 100) / total) + '%';
        var next = doc.querySelector('[data-mw-loadmore]');
        if (next) {
          a.setAttribute('href', next.getAttribute('href'));
          a.textContent = label;
          a.removeAttribute('aria-busy');
        } else {
          a.remove();
        }
      })
      .catch(function () { window.location.href = url.toString(); });
  }

  /* Mobile filter pills: one pill per filter group, opening the filter panel at that group */
  function buildPills() {
    var bar = q('[data-mw-pills]');
    if (!bar) return;
    document.querySelectorAll('.mw-filters details.mw-fgroup').forEach(function (d, i) {
      var s = d.querySelector('summary');
      if (!s) return;
      var cnt = s.querySelector('.mw-fgroup__count');
      var name = s.textContent;
      if (cnt) name = name.replace(cnt.textContent, '');
      name = name.replace(/\s+/g, ' ').trim();
      var b = el('button', 'mw-pill' + (cnt ? ' is-active' : ''), name + (cnt ? ' ' + cnt.textContent.trim() : ''));
      b.type = 'button';
      b.setAttribute('data-mw-pill', String(i));
      bar.appendChild(b);
    });
  }
  function openGroup(i) {
    document.documentElement.classList.add('mw-filters-open');
    var d = document.querySelectorAll('.mw-filters details.mw-fgroup')[parseInt(i, 10)];
    if (!d) return;
    d.open = true;
    setTimeout(function () { d.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 280);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var quick = t.closest('[data-mw-quick]');
    if (quick) { e.preventDefault(); open(quick.closest('[data-mw-card]')); return; }
    if (t.closest('[data-mw-sheet-close]')) { close(); return; }
    if (t.closest('[data-mw-sheet-add]')) { add(); return; }
    var more = t.closest('[data-mw-loadmore]');
    if (more) { e.preventDefault(); loadMore(more); return; }
    var pill = t.closest('[data-mw-pill]');
    if (pill) { openGroup(pill.getAttribute('data-mw-pill')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* Keep the mobile filter bar tucked right under the site header, even when the header
     hides/shows on scroll: measure where the header's bottom edge is and stick below it. */
  var headerEl = null;
  var ticking = false;
  function findHeader() {
    return document.querySelector('.shopify-section--header') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header');
  }
  function setStickyTop() {
    ticking = false;
    if (!headerEl) headerEl = findHeader();
    var top = 0;
    if (headerEl) {
      var pos = getComputedStyle(headerEl).position;
      if (pos === 'sticky' || pos === 'fixed') top = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
    }
    document.documentElement.style.setProperty('--mw-sticky-top', top + 'px');
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(setStickyTop); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function init() {
    buildPills();
    setStickyTop();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
